import crypto from 'crypto-js'

/**
 * md5加密
 * @param {String} str - 要加密的字符串
 * @returns {*}
 */
const md5 = str => crypto.MD5(str).toString()

export default {
  md5
}
